import { NavSeparator } from '@app/components/layout/sidenav/base';
import { NavStateToggler } from '@app/components/layout/sidenav/footer/NavStateToggler';
import { AuthData } from '@app/core/auth/authentication/types';
import { UserInfo } from '@app/core/auth/profile';
import { Box } from '@mui/material';
import { UserActions } from './UserActions';

export function NavFooter(_p: { auth: AuthData; timezone: string | null }) {
  return (
    <Box sx={{ marginTop: 'auto' }}>
      <UserInfo />
      <UserActions />
      <NavSeparator />
      <NavStateToggler />
    </Box>
  );
}
